/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  steps: [],
  activeStep: 0,
  newLeg: {},
};

const stepSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    nextStep(state, { payload }) {
      const { container, data, steps } = payload;

      state.activeStep += 1;
      state.steps = steps;
      state[container] = data;
    },
    reset: () => (initialState),
  },
});

export const {
  reset,
  nextStep,
} = stepSlice.actions;

export default stepSlice.reducer;
